<ng-container *ngIf="!isExterneApp; else externeApp">
  <div class="dashboard-panel" (mouseenter)="showHoverImage(hoverSvg)" (mouseleave)="showDefaultImage(svg)">
    <div *ngIf="badgeCount && badgeCount > 0" class="dashboard-badge" [matBadge]="badgeCount"></div>
    <div *ngIf="hasNotification" class="dashboard-notification">
      <div class="dashboard-circle"></div>
    </div>
    <div class="dashboard-icon" [innerHtml]="activeSvg">
      <ng-content></ng-content>
    </div>
    <div class="learn-more" *ngIf="showLearnMore" [class.one-ep-colors]="oneEPColors">
      <button class="btn btn-learn-more" *ngIf="!showCreateTeaser">MEHR ERFAHREN</button>
      <button class="btn btn-learn-more" *ngIf="showCreateTeaser">TEASER ERSTELLEN</button>
    </div>
    <h3 class="dashboard-title">{{ title }}</h3>
    <p *ngIf="showPremium" class="premium-label">PREMIUM</p>
  </div>
</ng-container>

<ng-template #externeApp>
  <div class="dashboard-panel">
    <app-features-icon-app
      [icon]="externeIcon"
      [hoverIcon]="hoverExterneIcon"
      [disabled]="isTeaser"
      [isTeaser]="isTeaser"
      [canCreateTeaser]="isNewTeaserText"
      dashboard="true"
    ></app-features-icon-app>
    <h3 class="dashboard-title">{{ title }}</h3>
  </div>
</ng-template>
